import React from "react";
import { PlusIcon } from "@heroicons/react/24/solid";
import Popover from "../../../componentLibrary/Popover";
import TabGroup from "../../../componentLibrary/TabGroup";
import FloatingActionButton from "../../../componentLibrary/FloatingActionButton";
import { useNotification } from "../../../hooks/useNotification";

export default function NavigationComponents() {
  const { notify } = useNotification();
  const tabData = [
    {
      label: "Modules",
      content: (
        <div>
          <h3>Tab 1 Content</h3>
          <p>This is the content for Tab 1.</p>
        </div>
      ),
    },
    {
      label: "Skills",
      content: (
        <div>
          <h3>Tab 2 Content</h3>
          <p>This is the content for Tab 2.</p>
        </div>
      ),
    },
    {
      label: "Journal",
      content: (
        <div>
          <h3>Tab 3 Content</h3>
          <p>This is the content for Tab 3.</p>
        </div>
      ),
    },
  ];

  return (
    <>
      <h2 className="underline">Navigation & Menus</h2>

      <div className="space-y-6">
        {/* Popover Menu */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Popover Menu
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Contextual dropdown menus that appear on button click. Used for
              component selection in lesson creation and other contextual
              actions. Provides a clean way to present multiple options without
              cluttering the interface.
            </p>
          </div>
          <Popover
            buttonBody={<PlusIcon className="h-6 w-6" />}
            options={[
              {
                label: "Add Module",
                onClick: () => notify("success", "Add Module clicked"),
              },
              {
                label: "Add Lesson",
                onClick: () => notify("success", "Add Lesson clicked"),
              },
              {
                label: "Add Icon",
                onClick: () => notify("success", "Add Icon clicked"),
              },
            ]}
          />
        </div>

        {/* Tab Group */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Tab Group</h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Navigation component for organizing content into logical sections.
              Used in lesson creation, content management, and data
              organization. Provides clean separation of related content and
              improves user navigation through complex interfaces.
            </p>
          </div>
          <TabGroup tabs={tabData} />
        </div>

        {/* Floating Action Button */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Floating Action Button
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Persistent action button that floats above content. Used for quick
              access to primary actions like adding new content or accessing
              frequently used features. Provides always-available access to key
              functionality.
            </p>
          </div>
          <div className="flex justify-center">
            <FloatingActionButton
              variant="primary"
              onClick={() =>
                notify("success", "You clicked the Floating Action Button")
              }
              className="p-2"
              title="Information"
            >
              <PlusIcon className="w-8 h-8 text-white" />
            </FloatingActionButton>
          </div>
        </div>
      </div>
    </>
  );
}
